var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { UnitTreeNode, UnitTreeService } from './unit.service';
var UnitComponent = /** @class */ (function (_super) {
    __extends(UnitComponent, _super);
    function UnitComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.all_events = [
            'init.jstree',
            'loading.jstree',
            'loaded.jstree',
            'ready.jstree',
            'load_node.jstree',
            'load_all.jstree',
            'model.jstree',
            'redraw.jstree',
            'before_open.jstree',
            'open_node.jstree',
            'after_open.jstree',
            'close_node.jstree',
            'after_close.jstree',
            'open_all.jstree',
            'close_all.jstree',
            'enable_node.jstree',
            'disable_node.jstree',
            'hide_node.jstree',
            'show_node.jstree',
            'hide_all.jstree',
            'show_all.jstree',
            'activate_node.jstree',
            'hover_node.jstree',
            'dehover_node.jstree',
            'select_node.jstree',
            'changed.jstree',
            'deselect_node.jstree',
            'select_all.jstree',
            'deselect_all.jstree',
            'set_state.jstree',
            'refresh.jstree',
            'refresh_node.jstree',
            'set_id.jstree',
            'set_text.jstree',
            'create_node.jstree',
            'rename_node.jstree',
            'delete_node.jstree',
            'move_node.jstree',
            'copy_node.jstree',
            'cut.jstree',
            'copy.jstree',
            'paste.jstree',
            'clear_buffer.jstree',
            'set_theme.jstree',
            'show_stripes.jstree',
            'hide_stripes.jstree',
            'show_dots.jstree',
            'hide_dots.jstree',
            'show_icons.jstree',
            'hide_icons.jstree',
            'show_ellipsis.jstree',
            'hide_ellipsis.jstree',
            'disable_checkbox.jstree',
            'enable_checkbox.jstree',
            'check_node.jstree',
            'uncheck_node.jstree',
            'check_all.jstree',
            'uncheck_all.jstree',
            'show_contextmenu.jstree',
            'search.jstree',
            'clear_search.jstree',
            'state_ready.jstree'
        ];
        _this.plugins = [
            'wholerow',
            'checkbox',
            'search',
            'dnd',
            'types'
        ];
        _this.limit = 10;
        _this.search = false;
        _this.tree_data = new Subject();
        _this.ignore_events = ['hover_node.jstree', 'dehover_node.jstree'];
        _this.is_control_tree_monitor = false;
        _this.move = [];
        return _this;
    }
    UnitComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        if (this.component.params && this.component.params.limit) {
            this.limit = this.component.params.limit;
        }
        this.element = this.treeElement.nativeElement;
        this.init();
    };
    UnitComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        if (this.cols.length > 0 && this.component.params && this.component.params.horizontal === true) {
            for (var _i = 0, _a = this.cols; _i < _a.length; _i++) {
                var col = _a[_i];
                $.extend(true, col, { params: { formClass: { horizontal: true } } });
            }
        }
    };
    UnitComponent.prototype.tree = function () {
        return $(this.element).jstree(true);
    };
    ;
    UnitComponent.prototype.init = function () {
        var _this = this;
        var self = this;
        this.tree_data.subscribe(function (data) {
            var coreData = function ($node, cb) {
                if ($node.id === '#') {
                    cb(data);
                }
                else {
                    var load_data = self.onLoadNode($node);
                    cb(load_data);
                }
            };
            var tree = self.tree();
            if (!tree) {
                $(self.element).jstree({
                    core: {
                        check_callback: function (operation, node, parent, position, more) {
                            if (operation === 'move_node') {
                                if (node.type === 'more' || (more.ref && more.ref.type === 'more')) {
                                    return false;
                                }
                            }
                            return true;
                        },
                        data: coreData,
                        themes: {
                            icons: false
                        }
                    },
                    checkbox: {
                        keep_selected_style: false,
                        whole_node: false,
                        tie_selection: false,
                        visible: false
                    },
                    search: {
                        show_only_matches: true
                    },
                    types: {
                        more: {
                            valid_children: []
                        }
                    },
                    dnd: {
                        large_drop_target: true,
                        large_drag_target: true
                    },
                    plugins: _this.plugins
                });
            }
            else {
                tree.settings.core.data = coreData;
                $(self.element).jstree('refresh');
            }
        });
        var events = this.all_events.filter(function (element) {
            return _this.ignore_events.indexOf(element) == -1;
        });
        $(this.element).on(events.join(' '), function (e, data) {
            self.onEvent(e, e.type, data);
        });
    };
    UnitComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    UnitComponent.prototype.onSubscribe = function (rec) {
        if (rec instanceof Array) {
            this.org_data = rec;
            this.onSearchClear();
            this.move = [];
            this.action.setRec(this.move);
        }
    };
    UnitComponent.prototype.applyToTreeData = function (recs) {
        this.is_control_tree_monitor = true;
        this.tree_data.next(this.createTreeData(recs));
        this.is_control_tree_monitor = false;
    };
    UnitComponent.prototype.createTreeData = function (recs) {
        var data = [];
        for (var _i = 0, recs_1 = recs; _i < recs_1.length; _i++) {
            var rec = recs_1[_i];
            data.push(new UnitNode(rec, this.search));
            if (data.length == this.limit && this.limit < recs.length && !this.search) {
                data.push(this.createMoreNode());
                break;
            }
        }
        return data;
    };
    UnitComponent.prototype.onEvent = function (e1, e2, rec) {
        if (e2 === 'move_node') {
            this.onMoveNode(rec);
        }
        else if (e2 === 'select_node') {
            if (rec.node.type === 'more' && rec.event.type === 'click') {
                this.onMoreNode(rec);
            }
        }
        else if (e2 === 'load_node') {
            if (this.search) {
                this.search = false;
                this.tree().search(this.treeSearch);
            }
        }
    };
    UnitComponent.prototype.onMoveNode = function (rec) {
        this.move.push({
            operation: 'move',
            params: {
                id: rec.node.id,
                from: (rec.old_parent === '#' ? 0 : rec.old_parent),
                to: (rec.parent === '#' ? 0 : rec.parent)
            }
        });
        this.action.setRec(this.move);
        var from_recs = (rec.old_parent === '#' ? this.org_data : jsonpath.value(this.org_data, '$..[?(@.id==' + rec.old_parent + ')]').children);
        var target_rec = from_recs.splice(rec.old_position, 1);
        var to_recs = (rec.parent === '#' ? this.org_data : jsonpath.value(this.org_data, '$..[?(@.id==' + rec.parent + ')]').children);
        to_recs.splice(rec.position, 0, target_rec[0]);
    };
    UnitComponent.prototype.onLoadNode = function (rec) {
        var recs = jsonpath.value(this.org_data, '$..[?(@.id==' + rec.id + ')]');
        recs = recs.children;
        return this.createTreeData(recs);
    };
    UnitComponent.prototype.onMoreNode = function (rec) {
        var node = rec.node;
        var parent_node = this.tree().get_node(node.parent);
        var scrollTop = $(window).scrollTop();
        var page = node.data.page;
        var offset = parent_node.children.indexOf(node.id);
        var recs = (node.parent === '#' ? this.org_data : jsonpath.value(this.org_data, '$..[?(@.id==' + node.parent + ')]').children);
        var count = 0;
        this.tree().delete_node(node);
        for (var i = offset; i < recs.length; i++) {
            this.tree().create_node(parent_node, new UnitNode(recs[i], this.search));
            count++;
            if (count == this.limit && offset + this.limit < recs.length && !this.search) {
                this.tree().create_node(parent_node, this.createMoreNode(page + 1));
                break;
            }
        }
        $(window).scrollTop(scrollTop);
    };
    UnitComponent.prototype.createMoreNode = function (page) {
        if (page === void 0) { page = 1; }
        return new UnitNode({ more: true, page: page }, this.search, this.msgSnapshot);
    };
    UnitComponent.prototype.onChangeSearch = function (value) {
        this.tree().search(value);
    };
    UnitComponent.prototype.onSearch = function () {
        if (!this.treeSearch) {
            return;
        }
        this.search = true;
        this.applyToTreeData(this.org_data);
    };
    UnitComponent.prototype.onSearchClear = function () {
        this.search = false;
        this.treeSearch = '';
        if (this.tree()) {
            this.tree().clear_search();
        }
        this.applyToTreeData(this.org_data);
    };
    UnitComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.tree_data.unsubscribe();
    };
    UnitComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'unit',
                    template: "<form id=\"{{ componentName }}\">\n  <p>{{ (msg | async)['UnitComponent.label.note1'] }}</p>\n  <ul [key]=\"'btn'\" buttonDir>\n    <li [key]=\"'btn'\" buttonDir>\n      <input type=\"text\" class=\"checkTree_searchInput\" placeholder=\"{{ (msg | async)['Search...'] }}\" name=\"treeSearch\" [(ngModel)]=\"treeSearch\">\n    </li>\n    <li [key]=\"'btn'\" buttonDir>\n      <item-btn [key]=\"'btn'\" [btn]=\"{\n                                    type: 'button',\n                                    event: componentName + '#Button#search',\n                                    caption: (msg | async)['SearchConditionComponent.button.search'],\n                                    params: {btnClass: {sm: true}}\n                                }\" (clickBtn)=\"onSearch()\"></item-btn>\n    </li>\n    <li [key]=\"'btn'\" buttonDir>\n      <item-btn [key]=\"'btn'\" [btn]=\"{\n                                    type: 'button',\n                                    event: componentName + '#Button#searchClear',\n                                    caption: (msg | async)['SearchConditionComponent.button.clear'],\n                                    params: {btnClass: {sm: true, type: 'delete'}}\n                                }\" (clickBtn)=\"onSearchClear()\"></item-btn>\n    </li>\n  </ul>\n  <div #tree></div>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    UnitComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: UnitTreeService }
    ]; };
    UnitComponent.propDecorators = {
        treeElement: [{ type: ViewChild, args: ['tree',] }]
    };
    return UnitComponent;
}(ContentBaseComponent));
export { UnitComponent };
var UnitNode = /** @class */ (function (_super) {
    __extends(UnitNode, _super);
    function UnitNode(rec, search, msg) {
        if (msg === void 0) { msg = {}; }
        var _this = _super.call(this, rec) || this;
        if (rec['id'] != null) {
            _this.id = rec.id;
            rec.node_id = _this.id;
        }
        var attr_class = [];
        if (rec['disable'] != null) {
            _this.state.disabled = rec.disable;
            if (rec.disable) {
                attr_class.push('checkTree_disabled');
            }
        }
        if (rec['grant'] != null && !rec['grant']) {
            attr_class.push('checkTree_locked');
            _this.text = '<img src="img/icon_locked.svg" alt="" width="14">' + rec.label;
        }
        _this.a_attr.class = attr_class.join(' ');
        if (rec != null) {
            if (rec['children'] != null) {
                if (search) {
                    _this.children = [];
                    for (var _i = 0, _a = rec['children']; _i < _a.length; _i++) {
                        var child = _a[_i];
                        _this.children.push(new UnitNode(child, search));
                    }
                }
                else if (rec['children'].length > 0) {
                    _this.children = true;
                }
            }
        }
        if (rec['more']) {
            _this.text = '<a href="javascript:void(0);">' + msg['au.COMPONENTS.label.tree.more'] + '</a>';
            _this.type = 'more';
            _this.li_attr.class = 'checkTree_more';
        }
        return _this;
    }
    return UnitNode;
}(UnitTreeNode));
//# sourceMappingURL=unit.component.js.map